/**
 * @generated SignedSource<<b712db637dc5526f65d5e2776bbc46d1>>
 * @relayHash 3e5f50334a833356bade8dcc1802689c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99f2e17660825bfdf24015d2f280ce7f4250d15c6cc0fb49f7770602d4a1a510

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionBacklogPanelRelayQuery } from './uiVersionBacklogPanelRelayQuery.graphql';

import isManageVersionsPermissionEnabled_provider from '@atlassian/jira-relay-provider/src/is-manage-versions-permission-enabled.relayprovider';
import isVisualRefreshEAPEnabled_provider from '@atlassian/jira-relay-provider/src/visual-refresh-eap-2.relayprovider';

const node: PreloadableConcreteRequest<uiVersionBacklogPanelRelayQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "99f2e17660825bfdf24015d2f280ce7f4250d15c6cc0fb49f7770602d4a1a510",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "uiVersionBacklogPanelRelayQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": isVisualRefreshEAPEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": isManageVersionsPermissionEnabled_provider
    }
  }
};

export default node;
